import React from 'react';
import { Box, Dialog, DialogTitle, DialogContent } from '@mui/material';
import { CarveOutView } from '../../../../../../services/ContractService/types/contractTypes';
import { useCarveOutForm } from './hooks';
import {
    CarveOutFormFields,
    RateField,
    CarveOutCheckboxes,
    RateSummary,
    DialogActionButtons
} from './components';

interface AddEditCarveOutDialogProps {
    open: boolean;
    editingCarveOut: CarveOutView | null;
    contractId: string;
    onClose: () => void;
}

const AddEditCarveOutDialog: React.FC<AddEditCarveOutDialogProps> = ({
    open,
    editingCarveOut,
    contractId,
    onClose,
}) => {
    const {
        formData,
        formErrors,
        isLoading,
        isDeleting,
        handleFormChange,
        handleSave,
        handleDelete
    } = useCarveOutForm({
        editingCarveOut,
        contractId,
        open,
        onClose
    });

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>
                {editingCarveOut ? 'Edit CarveOut' : 'Add CarveOut'}
            </DialogTitle>
            <DialogContent>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 1 }}>
                    <CarveOutFormFields
                        code={formData.code}
                        description={formData.description}
                        codeError={formErrors.code}
                        descriptionError={formErrors.description}
                        onCodeChange={(value) => handleFormChange('code', value)}
                        onDescriptionChange={(value) => handleFormChange('description', value)}
                    />

                    <RateField
                        rate={formData.rate}
                        error={formErrors.rate}
                        onChange={(value) => handleFormChange('rate', value)}
                    />

                    <CarveOutCheckboxes
                        applyMultiProcedureDisc={formData.applyMultiProcedureDisc}
                        isCaseRate={formData.isCaseRate}
                        onMultiProcChange={(checked) => handleFormChange('applyMultiProcedureDisc', checked)}
                        onCaseRateChange={(checked) => handleFormChange('isCaseRate', checked)}
                    />

                    <RateSummary
                        rate={formData.rate}
                        isCaseRate={formData.isCaseRate}
                        applyMultiProcedureDisc={formData.applyMultiProcedureDisc}
                    />
                </Box>
            </DialogContent>

            <DialogActionButtons
                isEditing={!!editingCarveOut}
                isLoading={isLoading}
                isDeleting={isDeleting}
                onCancel={onClose}
                onDelete={handleDelete}
                onSave={handleSave}
            />
        </Dialog>
    );
};

export default AddEditCarveOutDialog;
